let ClosedModal = function() {
	this.SettingBox = "";
};
export default ClosedModal;
